// extracted by mini-css-extract-plugin
export var printerCard = "_hx-1";
export var printerCardConfigured = "_hx-2";
export var printerCardError = "_hx-3";
export var printerCardsContainer = "_hx-0";
export var printerIcon = "_hx-8";
export var printerIconConfigured = "_hx-5";
export var printerIconContainer = "_hx-4";
export var printerIconError = "_hx-6";
export var printerIconUnconfigured = "_hx-7";
export var workstationsTableCard = "_hx-9";